// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__2gMEi","body":"styles_body__25ea6","item":"styles_item__1ek1K","more":"styles_more__MH1LK"};